(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carte-de-contenu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-content-cards-section]');

    const setActiveDot = (dots, activeIndex) => {
      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    sections.forEach((sectionEl) => {
      const track = sectionEl.querySelector('[data-track]');
      const dots = [...sectionEl.querySelectorAll('[data-dot]')];
      const slides = [...sectionEl.querySelectorAll('[data-slide]')];

      if (!track || dots.length === 0 || slides.length === 0) return;

      let ticking = false;

      const updateFromScroll = () => {
        const viewportCenter = track.scrollLeft + track.clientWidth / 2;
        let activeIndex = 0;
        let minDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          const distance = Math.abs(slideCenter - viewportCenter);
          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = index;
          }
        });

        setActiveDot(dots, activeIndex);
      };

      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          updateFromScroll();
          ticking = false;
        });
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const slide = slides[index];
          if (!slide) return;
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          setActiveDot(dots, index);
        });
      });

      updateFromScroll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-creative"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cc-filters-popup]').forEach(function (popup) {
      var sectionRoot = popup.closest('.collection-creative');
      if (!sectionRoot) return;

      var triggers = sectionRoot.querySelectorAll('[data-cc-open-filters]');
      var closers = popup.querySelectorAll('[data-cc-close-filters]');

      function open() {
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cc-filters-open');
        triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      }

      function close() {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('cc-filters-open');
        triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      }

      triggers.forEach(function (t) { t.addEventListener('click', open); });
      closers.forEach(function (c) { c.addEventListener('click', close); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-custom"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list-split-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-collection-menu]').forEach(function (menu) {
      var sectionEl = menu.closest('.section-split-carousel');
      if (!sectionEl) return;

      var triggers = menu.querySelectorAll('[data-collection-tab-trigger]');
      var panels   = sectionEl.querySelectorAll('[data-collection-tab-panel]');

      if (!triggers.length || !panels.length) return;

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var targetId = trigger.getAttribute('data-collection-tab-target');

          triggers.forEach(function (btn) {
            var isActive = btn === trigger;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-collection-tab-id') === targetId);
          });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.section-resource-list__category-menu').forEach(function (menu) {
      var section = menu.closest('.section-resource-list');
      if (!section) {
        return;
      }

      var triggers = menu.querySelectorAll('[data-collection-tab-trigger]');
      var panels = section.querySelectorAll('[data-collection-tab-panel]');

      if (!triggers.length || !panels.length) {
        return;
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var targetId = trigger.getAttribute('data-collection-tab-target');

          triggers.forEach(function (btn) {
            var isActive = btn === trigger;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-collection-tab-id') === targetId);
          });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-editorial-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reviews-editorial]').forEach((sectionEl) => {
    if (sectionEl.dataset.reviewsEditorialInit === 'true') {
      return;
    }

    sectionEl.dataset.reviewsEditorialInit = 'true';

    const track = sectionEl.querySelector('[data-review-track]');
    const prevButton = sectionEl.querySelector('[data-direction="prev"]');
    const nextButton = sectionEl.querySelector('[data-direction="next"]');

    if (!track || !prevButton || !nextButton) {
      return;
    }

    const getScrollAmount = () => Math.max(track.clientWidth * 0.75, 240);

    prevButton.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
